import { render } from "./bank-settings-grid.vue?vue&type=template&id=5df20a10"
import script from "./bank-settings-grid.vue?vue&type=script&lang=js"
export * from "./bank-settings-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__